<template>
  <div class="board-content">
    <h2>Reports</h2>

    <div class="search-form">
      <div class="target">
        <label>
          <input type="radio"
                 value="url"
                 v-model.trim="target" />
          URL
        </label>
        <label>
          <input type="radio"
                 value="group"
                 v-model.trim="target" />
          Group name
        </label>
      </div>
      <input type="text"
             id="keyword"
             v-model.trim="keyword"
             placeholder="Search"
             @keyup.enter="onSearchSubmit" />
      <button type="button"
              @click="onSearchSubmit">
        <i class="icon icon--search"
           title="Search"></i>
      </button>
    </div>

    <div class="reports-list">
      <div class="group-list">
        <div class="group">
          <div class="name"
               :class="{ active: !currentGroup }">
            <router-link :to="{ name: $route.name, query: { group: null } }">
              Default Group
              <span class="count">
                {{ reportGroups.length }}
              </span>
            </router-link>
          </div>
        </div>

        <div class="folders">
          <ul>
            <li v-for="folder in reportGroups"
                :key="'folder' + folder.id"
                :class="{ active: currentGroup === folder.id, edit: folder.isEditMode }">
              <template v-if="!folder.isEditMode">
                <router-link :to="{ name: $route.name, query: { group: folder.id } }">
                  <i class="icon icon--folder"
                     :class="{ 'icon--folder-red': currentGroup === folder.id }"></i>
                  <span class="name">
                    {{ folder.name }}
                  </span>
<!--                  <span class="count">-->
<!--                    {{ folder.reportDataCount }}-->
<!--                  </span>-->
                </router-link>
                <div class="buttons">
                  <button type="button"
                          @click="onAddGroupClick">
                    <i class="icon icon--plus-gray"></i>
                  </button>
                  <span class="bar"></span>
                  <button type="button"
                          @click="onEditGroupNameClick(folder)">
                    <i class="icon icon--pen"></i>
                  </button>
                  <span class="bar"></span>
                  <button type="button"
                          @click="onRemoveGroupClick(folder)">
                    <i class="icon icon--trash"></i>
                  </button>
                </div>
              </template>
              <template v-else>
                <input type="text"
                       v-model="folder.name">
                <div class="buttons">
                  <button type="button"
                          @click="onEditGroupNameClick(folder)">
                    <i class="icon icon--check-green"></i>
                  </button>
                  <button type="button"
                          @click="folder.isEditMode = false">
                    <i class="icon icon--close"></i>
                  </button>
                </div>
              </template>
            </li>
          </ul>
        </div>

        <add-group-layer v-if="showGroupAddLayer"
                         @onAddGroup="onAddGroup" />
      </div>

      <div class="report-list">
        <div class="pagination">
          <pagination :currentPage="currentPage"
                      :totalPage="totalPage"
                      :routeName="'Main'"/>
        </div>

        <div class="reports"
             v-if="reportList && reportList.length">
          <template v-for="(subItem, index) in reportList">
            <div class="group-title"
                 v-if="index === 0 || reportList[index - 1].ReportGroup.id !== subItem.ReportGroup.id"
                 :key="subItem.id + 'group'">
              <p v-if="searchTarget === 'group'" v-html="highlight(subItem.ReportGroup.name, searchKeyword)"></p>
              <p v-else v-html="subItem.ReportGroup.name"></p>
            </div>
            <div :key="subItem.id"
                 class="report-data"
                 v-if="searchTarget !== 'url' || RegExp(searchKeyword, 'gi').test(subItem.url)">
              <div class="handle">
                <!--<input type="checkbox" />-->
              </div>
              <div class="thumbnail">
                <div v-if="subItem.Reports[0]"
                     class="thumb"
                     :style="`background-image: url('${apiImageUrl(subItem.Reports[0].thumbnailUrl)}')`"></div>
                <button type="button"
                        class="rediagnosis"
                        :disabled="!!diagnosingId"
                        @click="onRestartClick(subItem)">
                  <i class="icon icon--rediagnosis"></i>
                  {{ $t('diagnostics.reDiagnosis') }}
                </button>
              </div>
              <div class="description">
                <div class="title">
                  <span class="index">
                    {{ subItem.index }}
                  </span>
                  <span class="name">
                    <span v-if="!subItem.isEditMode">{{ subItem.title }}</span>
                    <input v-else type="text" name="" v-model.trim="subItem.title" maxlength="50"
                           @keyup.enter="onEditReportDataNameClick(subItem)" />
                  </span>
<!--                      <button type="button" class="btn_write"-->
<!--                              @click="onEditReportDataNameClick(subItem)"><span class="haze">수정</span></button>-->
                </div>
                <div class="type">
                  <a :href="subItem.url"
                     target="_blank"
                     :title="`${subItem.url} : ${$t('common.openNewWindow')}`">
                    <span class="report-type"
                          v-if="subItem.deviceType > 10">
                      File
                    </span>
                      <span class="report-type"
                            v-else>
                      URL
                    </span>
                    <span v-if="searchTarget === 'url'"
                          v-html="highlight(subItem.url, searchKeyword)"></span>
                    <span v-else
                          v-html="subItem.url"></span>
                  </a>
                </div>
                <div class="more-info">
                  <p>
                    {{ $t('diagnostics.createdAt') }} : {{ subItem.createdAt | yymmddhhmm }}
                  </p>
                  <p>
                    <span>
                      {{ $t('report.loginInfo') }} : {{ subItem.requireLogin ? $t('report.set') : $t('report.notAvailable') }}
                      <span class="bar"></span>
                    </span>
                    <span>
                      {{ $t('report.excludeElements') }} : {{ subItem.useExcludeSelectors ? $t('report.set') : $t('report.notAvailable') }}
                      <span class="bar"></span>
                    </span>
                    <span>
                      {{ $t('report.includeElements') }} : {{ subItem.useIncludeSelectors ? $t('report.set') : $t('report.all') }}
                    </span>
                  </p>
                </div>
                <div class="data">
                  <div v-if="subItem.Reports[0]" class="group_info">
                    <report-list :reports="subItem.Reports" />
                  </div>
                </div>
              </div>
              <div class="buttons">
                <div class="buttons-wrap">
                  <button type="button"
                          @click="onRemoveReportDataClick(subItem.ReportGroup.id, subItem)">
                    <i class="icon icon--trash"></i>
                  </button>
                </div>
              </div>
            </div>
          </template>
        </div>
        <div class="no-result"
             v-else>
          <p>
            <i class="icon icon--empty"></i><br>
            {{ $t('dashboard.noPages') }}
          </p>
        </div>

        <div class="pagination">
          <pagination :currentPage="currentPage"
                      :totalPage="totalPage"
                      :routeName="'Main'"/>
        </div>
      </div>
    </div>

    <require-login-layer v-if="showRequireLoginLayer"
                         :reportData="activeReportData"
                         @onCloseClick="showRequireLoginLayer = false"
                         @onConfirmClick="onLoginInfoConfirm" />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import AddGroupLayer from './AddGroupLayer'
import RequireLoginLayer from './RequireLoginLayer'
import ReportList from './ReportList'
import pagination from '../pagination'
import reportGroupApi from '@/api/report-group'
import reportDataApi from '@/api/report-data'
import tempReportApi from '@/api/temp-report'
import modalEvent from '@/lib/modal-event'
import { apiImageUrl } from '@/lib/http-client'
import { highlight } from '@/lib/utils'
import ProgressBar from '@/components/global/ProgressBar'
import ajaxHandlerMixin from '@/mixins/ajax-handler'

export default {
  name: 'BoardContent',
  mixins: [ajaxHandlerMixin],
  components: {
    AddGroupLayer,
    RequireLoginLayer,
    ReportList,
    ProgressBar,
    pagination
  },
  data () {
    return {
      showRequireLoginLayer: false,
      activeReportData: null,
      model: {
        reportDataId: null
      },
      target: 'url',
      keyword: ''
    }
  },
  computed: {
    ...mapGetters(['reportGroupData', 'reportGroups', 'reportDataList', 'diagnosingId']),
    isEditMode: {
      get () {
        return this.reportGroupData.isEditMode
      },
      set (value) {
        this.setReportGroupEditMode(value)
      }
    },
    showGroupAddLayer: {
      get () {
        return this.reportGroupData.showGroupAddLayer
      },
      set (value) {
        this.setShowReportGroupAddLayer(value)
      }
    },
    groupList: {
      get () {
        return this.reportGroups
      }
    },
    reportList: {
      get () {
        const result = []
        let index = 1
        let group = null
        if (this.reportDataList.rows) {
          this.reportDataList.rows.forEach(row => {
            if (group !== row.ReportGroup.id) {
              index = 1
            }
            group = row.ReportGroup.id
            row.index = index
            index++
            result.push(row)
          })
        }
        return result
      }
    },
    totalPage: {
      get () {
        return Math.max(Math.ceil(this.reportDataList.count / 20), 1)
      }
    },
    currentPage: {
      get () {
        return Number(this.$route.query.page) || 1
      }
    },
    searchTarget: {
      get () {
        return this.$route.query.target || null
      }
    },
    searchKeyword: {
      get () {
        return this.$route.query.keyword || null
      }
    },
    currentGroup: {
      get () {
        return Number(this.$route.query.group) || null
      }
    }
  },
  watch: {
    '$route.query.page': {
      handler () {
        this.load()
      }
    },
    '$route.query.target': {
      handler () {
        this.load()
      }
    },
    '$route.query.keyword': {
      handler () {
        this.load()
      }
    },
    '$route.query.group': {
      handler () {
        this.load()
      }
    }
  },
  created () {
    if (this.searchKeyword) {
      this.target = this.searchTarget
      this.keyword = this.searchKeyword
    }
    this.setReportGroups([])
    this.load()
  },
  methods: {
    ...mapMutations(['setReportGroupEditMode', 'setShowReportGroupAddLayer',
      'deleteReportGroup', 'deleteReportData', 'setReportGroups']),
    ...mapActions(['fetchReportGroups', 'dashboardFetchReportList']),
    apiImageUrl (url) {
      return apiImageUrl(url)
    },
    highlight (haystack, needle) {
      return highlight(haystack, needle)
    },
    load () {
      if (this.searchKeyword) {
        this.keyword = this.searchKeyword
        this.target = this.searchTarget
      } else {
        this.keyword = ''
        this.target = 'url'
      }
      this.fetchReportGroups()
      this.dashboardFetchReportList({ page: this.currentPage, target: this.searchTarget, keyword: this.searchKeyword, group: this.currentGroup })
    },
    onSearchSubmit () {
      if (this.target && this.keyword) {
        this.$router.replace({
          query: {
            target: this.target,
            keyword: this.keyword
          }
        })
      } else {
        this.$router.replace({
          query: {}
        })
      }
    },
    onAddGroupClick () {
      this.setShowReportGroupAddLayer(true)
    },
    onRemoveGroupClick (group) {
      const groupId = group.id
      modalEvent.openDialog({
        message: 'dashboard.deleteGroupMessage',
        ok: 'common.delete',
        cancel: 'common.cancel'
      }).then(result => {
        if (result) {
          return reportGroupApi.remove(groupId)
        }
        throw this.getHandledError()
      }).then(response => {
        this.deleteReportGroup(groupId)
        modalEvent.openToast('common.deleted')
      }).catch(this.handleAjaxError)
    },
    onEditGroupNameClick (group) {
      if (!group.isEditMode) {
        group.isEditMode = true
        return
      }

      reportGroupApi.updateName(group.id, group.name).then(response => {
        modalEvent.openToast('common.updated').then(() => {
          group.isEditMode = false
        })
      }).catch(err => {
        this.handleAjaxError(err)

        if (this.isValidationError(err)) {
          const errorMessage = err.response.data
          modalEvent.openDialog({
            message: errorMessage,
            ok: 'common.confirm'
          })
        }
      })
    },
    onEditReportDataNameClick (report) {
      if (!report.isEditMode) {
        report.isEditMode = true
        return
      }

      reportDataApi.updateTitle(report.id, report.title).then(response => {
        modalEvent.openToast('common.updated').then(() => {
          report.isEditMode = false
        })
      }).catch(err => {
        this.handleAjaxError(err)

        if (this.isValidationError(err)) {
          const errorMessage = err.response.data
          modalEvent.openDialog({
            message: errorMessage,
            ok: 'common.confirm'
          })
        }
      })
    },
    onRemoveReportDataClick (groupId, reportData) {
      const reportDataId = reportData.id
      modalEvent.openDialog({
        message: 'dashboard.deletePageMessage',
        ok: 'common.delete',
        cancel: 'common.cancel'
      }).then(result => {
        if (result) {
          return reportDataApi.remove(reportDataId)
        }
        throw this.getHandledError()
      }).then(response => {
        this.deleteReportData({ groupId, reportDataId })
        this.load()
        modalEvent.openToast('common.deleted')
      }).catch(this.handleAjaxError)
    },
    onEditClick () {
      this.isEditMode = false

      if (this.reportGroups) {
        for (let i = 0; i < this.reportGroups.length; i++) {
          const group = this.reportGroups[i]
          group.isEditMode = false

          if (this.reportDataList) {
            for (let j = 0; j < this.reportDataList.length; j++) {
              this.reportDataList[j].isEditMode = false
            }
          }
        }
      }
    },
    onAddGroup (groupName) {
      this.setShowReportGroupAddLayer(false)
    },
    retryDiagnosis (reportData, loginId = null, loginPassword = null) {
      if (!this.diagnosingId) {
        reportData.isDiagnosis = true

        tempReportApi.retry(reportData.id, loginId, loginPassword).then(response => {
          const tempReportId = response.data.tempReportId
          if (tempReportId) {
            this.$emit('onRetryDiagnosis', tempReportId)
          } else {
            throw new Error('invalid tempReportId')
          }
        }).catch(err => {
          this.handleAjaxError(err)
        })
      }
    },
    onRestartClick (reportData) {
      if (reportData.deviceType > 10) {
        this.$emit('onShowDiagnosisClick', 'image')
        const scrollEl = document.scrollingElement || document.documentElement
        scrollEl.scrollTop = 0
      } else {
        this.loginUrl = null

        if (reportData.requireLogin) {
          this.activeReportData = reportData
          this.showRequireLoginLayer = true
        } else {
          this.retryDiagnosis(reportData)
        }
      }
    },
    onLoginInfoConfirm (loginId, loginPassword) {
      this.retryDiagnosis(this.activeReportData, loginId, loginPassword)
      this.showRequireLoginLayer = false
    }
  },
  destroyed () {
    this.onEditClick()
    modalEvent.resolveDialog(false)
  }
}
</script>

<style lang="scss" scoped>
.board-content {
  width: 1194px;
  padding: 0 15px;
  margin: 0 auto;

  h2 {
    font-size: 30px;
    font-weight: 600;
    color: #151515;
    padding-top: 55px;
    display: inline-block;
    margin: 0 10px;
  }

  .search-form {
    float: right;
    position: relative;
    padding-top: 60px;

    .target {
      display: inline-block;
      vertical-align: middle;
      margin-top: -2px;

      label {
        font-size: 14px;
        line-height: 1;
        color: #555555;

        input {
          margin-right: 8px;
          margin-left: 15px;
        }
      }
    }

    input[type=text] {
      width: 290px;
      height: 38px;
      line-height: 38px;
      margin: 0 0 0 13px;
      padding: 10px 12px 12px;
      border-radius: 6px;
      box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(0, 0, 0, 0.1);
      background-color: #ffffff;
      border: none;
      font-size: 14px;
      vertical-align: middle;
    }

    button {
      position: absolute;
      top: 79px;
      right: 13px;
      transform: translateY(-50%);
    }
  }

  .reports-list {
    margin-top: 15px;
    border-radius: 10px;
    box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.08);
    background-color: #ffffff;
    display: flex;

    .group-list {
      flex-basis: 289px;
      border-right: 1px solid #d1d1d1;
      box-shadow: inset -10px 0 10px -10px rgba(0, 0, 0, 0.08);
      flex-grow: 0;

      .group {
        margin: 29px 35px 17px 30px;

        .name {
          font-size: 16px;
          font-weight: 600;
          color: #444444;

          a {
            display: block;
          }

          .count {
            float: right;
            display: inline-block;
            vertical-align: middle;
            transition: opacity 0.15s ease;
            color: #555555;
            padding: 3px 5px;
            text-align: center;
            font-size: 12px;
            line-height: 12px;
            height: 12px;
            min-width: 8px;
            border-radius: 10px;
            border: solid 1px #cecece;
            margin-top: 2px;
          }

          &.active {
            color: #ec0047;

            .count {
              color: #ec0047;
              border-color: #ec0047;
            }
          }
        }
      }

      .folders {
        border-top: solid 1px rgba(0, 0, 0, 0.1);
        box-shadow: inset 0 10px 10px -10px rgba(0, 0, 0, 0.08);

        ul {
          margin: 17px 21px 17px 6px;
        }

        li {
          position: relative;
          padding: 0 12px 0 23px;
          margin: 6px 0;
          border-radius: 4px;
          border: 1px solid transparent;
          font-size: 14px;
          font-weight: 500;
          color: #444444;
          transition: border-color 0.2s ease,
                      box-shadow 0.2s ease;

          a {
            display: block;
            padding: 5px 0 6px;

            .name {
              display: inline-block;
              vertical-align: bottom;
              margin: 0;
              width: calc(100% - 55px);
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }

            .count {
              float: right;
              display: inline-block;
              vertical-align: middle;
              transition: opacity 0.15s ease;
              color: #555555;
              padding: 3px 5px;
              text-align: center;
              font-size: 12px;
              line-height: 12px;
              height: 12px;
              min-width: 8px;
              border-radius: 10px;
              border: solid 1px #cecece;
              margin-top: 1px;
            }
          }

          .buttons {
            position: absolute;
            top: 4px;
            right: 13px;
            opacity: 0;
            transition: opacity 0.15s ease;

            button {
              vertical-align: middle;
            }

            .bar {
              display: inline-block;
              vertical-align: middle;
              height: 12px;
              width: 1px;
              background-color: #d1d1d1;
              margin: 0 2px;
            }
          }

          &.active {
            color: #ec0047;

            a {
              .count {
                color: #ec0047;
                border-color: #ec0047;
              }
            }
          }

          &:hover {
            box-shadow: 0 3px 2px -2px rgba(0, 0, 0, 0.06);
            border-color: rgba(0, 0, 0, 0.12);

            a {
              .name {
                width: calc(100% - 105px);
              }

              .count {
                opacity: 0;
              }
            }

            .buttons {
              opacity: 1;
            }
          }

          &.edit {
            box-shadow: none;
            border-color: transparent;
            margin: -1px -5px;

            input[type=text] {
              width: 190px;
            }

            .buttons {
              margin-right: -12px;
              opacity: 1;

              .icon {
                margin-top: 3px;
              }
            }
          }
        }
      }
    }

    .report-list {
      padding-bottom: 10px;
      flex-grow: 1;
      display: flex;
      flex-direction: column;

      .pagination {
        flex-grow: 0;
      }

      .no-result {
        min-height: 545px;
        flex-grow: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        border-top: solid 1px #d7d7d7;
        border-bottom: solid 1px #d7d7d7;
        margin: -6px 25px -5px 20px;

        p {
          text-align: center;
          font-size: 13px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1;
          letter-spacing: normal;
          color: #767676;
          padding-bottom: 70px;

          i {
            margin-bottom: 10px;
          }
        }
      }

      .reports {
        margin: -5px 25px auto 20px;
        position: relative;
        flex-grow: 0;

        .group-title {
          font-size: 13px;
          font-weight: 500;
          line-height: 0.92;
          text-align: center;
          color: #666666;
          position: sticky;
          margin-top: -10px;
          top: 0;
          border-top: 10px solid #ffffff;

          p {
            width: calc(100% - 20px);
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            border-radius: 4px;
            box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, 0.12);
            background-color: #f5f5f5;
            padding: 5px 10px;
          }
        }

        .report-data {
          display: flex;
          border-bottom: 1px solid #d7d7d7;

          & + .group-title {
            margin-top: -10px;

            &::before {
              content: "";
              position: absolute;
              top: -1px;
              left: 0;
              width: 100%;
              height: 1px;
              background-color: #ffffff;
            }
          }

          .handle {
            flex-basis: 70px;
            flex-grow: 0;
            padding: 30px 20px 25px 0;
            text-align: right;
          }

          .thumbnail {
            flex-basis: 140px;
            flex-grow: 0;
            padding: 35px 0;

            .thumb {
              width: 100%;
              height: 100px;
              border-radius: 4px;
              box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(0, 0, 0, 0.1);
              background-color: #f4f4f1;
            }

            .rediagnosis {
              margin-top: 18px;
              width: 100%;
              padding: 6px 6px 6px 0;
              border-radius: 18px;
              border: solid 1px #ec0047;
              background-color: #ffffff;
              font-size: 15px;
              font-weight: 500;
              text-align: center;
              color: #ec0047;
              transition: opacity 0.2s ease;

              &:disabled {
                opacity: 0.2;
              }

              .icon {
                margin-right: 3px;
                margin-top: -2px;
              }
            }
          }

          .description {
            width: calc(100% - 90px - 140px - 111px - 70px);
            flex-grow: 0;
            padding: 30px 35px;

            .title {
              font-size: 18px;
              font-weight: 600;
              line-height: 1;

              .index {
                color: #ec0047;
                margin-right: 10px;
              }

              .name {
                color: #222222;
              }
            }

            .type {
              font-size: 14px;
              line-height: 1;
              color: #444444;
              margin: 5px 0;
              width: 440px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;

              .report-type {
                padding: 0 4px 0 5px;
                border-radius: 3px;
                border: solid 1px #c1c1c1;
                background-color: #ffffff;
                font-size: 11px;
                color: #767676;
                display: inline-block;
                vertical-align: middle;
                margin-right: 5px;
              }
            }

            .more-info {
              border-top: dashed 1px #d1d1d1;
              font-size: 13px;
              color: #444444;
              margin: 15px 0 5px;
              padding: 6px 0;
              font-weight: 300;

              p {
                margin: 6px 0;

                span {
                  white-space: nowrap;
                }
              }

              .bar {
                display: inline-block;
                width: 1px;
                height: 11px;
                margin: -2px 15px 0;
                vertical-align: middle;
                background-color: #d7d7d7;
              }
            }

            .data {

            }
          }

          .buttons {
            flex-basis: 111px;
            flex-grow: 0;
            padding: 33px 0;
            opacity: 0;
            transition: opacity 0.15s ease;

            .buttons-wrap {
              margin-left: 20px;
              display: inline-block;
              border-radius: 4px;
              box-shadow: 0 3px 2px -2px rgba(0, 0, 0, 0.06);
              border: solid 1px rgba(0, 0, 0, 0.12);
              background-color: #ffffff;

              button {
                padding: 7px;
              }
            }
          }

          &:hover {
            .buttons {
              opacity: 1;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/valid-member/dashboard/BoardContent.vue